import React from 'react';
import { Link } from 'react-router-dom';
import { STATIC_PATH_S3 } from '../../config';

const MainLink = ({ children, variant = 'black-icon', onClick, className, to }) => {
  const baseClass = 'main-link';
  const classes = [baseClass, `${baseClass}--${variant}`, className].join(' ');

  return (
    <Link to={to} className={classes} onClick={onClick}>
      <span className="main-link__text">{children}</span>
      {variant === 'black-icon' && (
        <div className="main-link__icon">
          <img src={`${STATIC_PATH_S3}main-page/arrow-btn.svg`} alt="arrow" />
        </div>
      )}
    </Link>
  );
};

export default MainLink;
